import { getLocaleStore } from '@/i18n/index';

/** 复制位移距离 */
export const COPY_DISTANCE = 30;

/** 最小字号 */
export const MIN_FONT_SIZE = 6;

/** 最大字号 */
export const MAX_FONT_SIZE = 8000; // 即画布的最大宽度

export const MAX_FONT_SIZE_FOR_EDGELESS = 5000; // 即画布的最大宽度

/** 图片缩放最小边数值限制 */
export const MIN_IMG_SIZE = 20;

/** 最大的画布个数 */
export const MAX_STAGES = 500;

/** 缩放最小边数值限制 */
export const LAYER_MIN_SIZE = 20;

/** 最大的画布个数提示 */
export const MAX_STAGES_TIP = () => {
    const { $t } = getLocaleStore();
    return $t((v, { r }) => r(v.stageManager.maxStageLimit, [MAX_STAGES]));
};
